import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type ScreenLevelSelectionState = Record<
  string,
  {
    brands?: number[];
    markets?: number[];
    segments?: number[];
  }
>;

const initialState: ScreenLevelSelectionState = {};

export const screenLevelSelectionSlice = createSlice({
  name: "screenLevelSelection",
  initialState,
  reducers: {
    updateScreenLevelSelection: (
      state: ScreenLevelSelectionState,
      action: PayloadAction<{
        screenType: keyof ScreenLevelSelectionState;
        value: Partial<
          ScreenLevelSelectionState[keyof ScreenLevelSelectionState]
        >;
      }>,
    ) => {
      const { screenType, value } = action.payload;
      state[screenType] = value;
    },
    resetScreenLevelSelection: () => {
      return initialState;
    },
  },
});

export const { updateScreenLevelSelection, resetScreenLevelSelection } =
  screenLevelSelectionSlice.actions;

export default screenLevelSelectionSlice.reducer;
